import React from 'react';
import PrivacyPolicyPage from './PrivacyPolicyPage';

const FoodRecipesPolicies = () => {
  return (
    <PrivacyPolicyPage
      title='CleanBowl Privacy Policy'
      intro={[
        'CleanBowl is provided by Kadjo Benjamin Anoh. This Privacy Policy explains how information is handled when you use CleanBowl for meal planning, nutrition tracking, barcode scanning, recipe discovery, recipe importing, reminders, and AI-powered food logging.',
        'CleanBowl does not store your personal information on developer-owned servers. Your profile, goals, saved recipes, meal logs, nutrition history, favorites, reminders, and other user input are stored on your device.',
      ]}
      sections={[
        {
          title: 'Information Stored on Your Device',
          paragraphs: [
            'CleanBowl may ask for profile and goal information such as age, height, weight, activity level, and nutrition goal. This information is used on your device to calculate personalized daily calorie and macro recommendations.',
            'You may also create or save recipes, favorite recipes, import recipes from the web, log meals, track nutrition, and save progress information. This user input is stored on your device and is used to provide the core features of the app.',
          ],
        },
        {
          title: 'Camera, Voice, and Barcode Use',
          paragraphs: [
            'CleanBowl may request access to your camera so you can scan meals, food labels, or barcodes. CleanBowl may also request microphone access if you choose to log food by voice.',
            'Camera and microphone access are optional and are only used when you choose to use those features. Camera, voice, barcode, and food-label input is used to help identify food and provide nutrition insights.',
          ],
        },
        {
          title: 'AI-Powered Features and Permission',
          paragraphs: [
            'CleanBowl includes optional AI-powered features for food logging, meal analysis, recipe assistance, and nutrition insights. When you choose to use an AI-powered feature, the app may send only the information needed for that request, such as the food description, image, barcode or label text, recipe URL or recipe content, or meal details you provide.',
            'CleanBowl uses Google Gemini as its third-party AI service provider for optional AI-powered food logging, meal analysis, recipe assistance, and nutrition insights.',
            'CleanBowl asks for your permission before sending personal food, image, voice, barcode, recipe, or meal-log input to Google Gemini. If you do not grant permission, CleanBowl will not send that input to Google Gemini.',
            'CleanBowl does not sell your personal information. Google Gemini must provide the same or equal protection for information shared for these features.',
          ],
        },
        {
          title: 'Recipe Import and External Links',
          paragraphs: [
            'If you import a recipe from the web, CleanBowl may process the recipe URL and recipe content so it can save ingredients, instructions, and nutrition-related information on your device.',
            'Some recipes or nutrition sources may link to third-party websites. Those websites are governed by their own privacy policies.',
          ],
        },
        {
          title: 'Notifications and Reminders',
          paragraphs: [
            'CleanBowl may request permission to send reminders and progress notifications. You can enable, disable, or change notification permissions in your device settings.',
          ],
        },
        {
          title: 'How Information Is Used',
          paragraphs: [
            'Information in CleanBowl is used to provide meal tracking, recipe recommendations, AI-powered food logging, nutrition summaries, barcode scanning, progress tracking, and personalized calorie and macro goals.',
            'CleanBowl does not use your locally stored personal information for advertising and does not sell your personal information.',
          ],
        },
        {
          title: 'Medical and Nutrition Disclaimer',
          paragraphs: [
            'CleanBowl provides wellness, food, and nutrition information for general informational purposes only. Calorie, macro, BMI, and other health-related calculations are estimates and may not be accurate for every person.',
            'CleanBowl is not a medical app and does not provide medical advice, diagnosis, or treatment. Please consult a qualified healthcare professional before making health, diet, exercise, or weight-management decisions.',
          ],
        },
        {
          title: 'Security',
          paragraphs: [
            'I value your trust and use reasonable safeguards to protect information handled by the app. However, no method of electronic storage or transmission is completely secure, and I cannot guarantee absolute security.',
          ],
        },
        {
          title: 'Children’s Privacy',
          paragraphs: [
            'CleanBowl is not intended to knowingly collect personal information from children under 13. If you believe a child has provided personal information, please contact me so it can be addressed.',
          ],
        },
      ]}
      citations={[
        {
          label:
            'Mifflin et al., A new predictive equation for resting energy expenditure in healthy individuals, PubMed',
          href: 'https://pubmed.ncbi.nlm.nih.gov/2305711/',
        },
        {
          label: 'Dietary Guidelines for Americans',
          href: 'https://www.dietaryguidelines.gov',
        },
        {
          label: 'CDC Adult BMI Categories',
          href: 'https://www.cdc.gov/bmi/adult-calculator/bmi-categories.html',
        },
      ]}
      effectiveDate='2026-05-20'
      contactEmail='benjaminanoh@gmail.com'
    />
  );
};

export default FoodRecipesPolicies;
